module.exports = __webpack_public_path__ + "img/withdraw.4b7c6af6.svg";